// extracted by mini-css-extract-plugin
export default {"h2":"Heading_h2__Hg9re"};